class RecipeLibrary extends HTMLElement {
  connectedCallback() {
    this.searchInput = this.querySelector('[data-recipe-search]');
    this.filters = Array.from(this.querySelectorAll('[data-recipe-filter]'));
    this.cards = Array.from(this.querySelectorAll('[data-recipe-card]'));
    this.emptyState = this.querySelector('[data-recipe-empty]');
    this.status = this.querySelector('[data-recipe-status]');
    this.activeCategory = 'all';

    this.searchInput?.addEventListener('input', () => this.update());
    this.filters.forEach((button) => {
      button.addEventListener('click', () => {
        this.activeCategory = button.dataset.recipeFilter || 'all';
        this.filters.forEach((filter) => {
          filter.setAttribute('aria-pressed', String(filter === button));
        });
        this.update();
      });
    });

    this.update();
  }

  update() {
    const query = (this.searchInput?.value || '').trim().toLowerCase();
    let visibleCount = 0;

    this.cards.forEach((card) => {
      const matchesSearch = !query || (card.dataset.recipeSearch || '').includes(query);
      const matchesCategory = this.activeCategory === 'all' || card.dataset.recipeCategory === this.activeCategory;
      const visible = matchesSearch && matchesCategory;
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;
    if (this.status) {
      const template = visibleCount === 1
        ? this.status.dataset.statusSingle || '[count] recipe'
        : this.status.dataset.statusTemplate || '[count] recipes';
      this.status.textContent = template.replace('[count]', visibleCount);
    }
  }
}

class RecipeDetail extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-recipe-source]');
    if (!this.content) return;
    this.prepareContent();
    this.querySelector('[data-recipe-print]')?.addEventListener('click', () => window.print());
  }

  prepareContent() {
    const nodes = Array.from(this.content.children).filter((node) => node.tagName !== 'HR');
    const fragment = document.createDocumentFragment();
    let card = null;

    nodes.forEach((node) => {
      if (node.tagName === 'H2') {
        card = document.createElement('section');
        card.className = 'fit-recipe-content-card';
        const label = node.textContent.trim().toLowerCase();
        if (/step|method|direction|preparation/.test(label)) card.classList.add('fit-recipe-content-card--steps');
        fragment.appendChild(card);
      }
      (card || fragment).appendChild(node);
    });

    this.content.replaceChildren(fragment);
  }
}

if (!customElements.get('recipe-library')) customElements.define('recipe-library', RecipeLibrary);
if (!customElements.get('recipe-detail')) customElements.define('recipe-detail', RecipeDetail);
